/**
 * Edge play-session token — authorize real play GBUX on poker.grudge-studio.com
 * without re-signing every action. Play GBUX = real product GBUX (not fake chips);
 * “play” means in-play on this dApp ledger. Header: X-Play-Session.
 */
import { getGrudgeToken } from "@/lib/grudge-auth";

const STORAGE_KEY = "budb_play_session_v1";

export type StoredPlaySession = {
  wallet: string;
  token: string;
  exp: number;
};

export function readPlaySession(wallet: string | null | undefined): StoredPlaySession | null {
  if (!wallet || wallet.length < 32 || typeof localStorage === "undefined") {
    return null;
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const j = JSON.parse(raw) as StoredPlaySession;
    if (j.wallet !== wallet || !j.token) return null;
    // 30s skew buffer
    if (!j.exp || j.exp < Date.now() + 30_000) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return j;
  } catch {
    return null;
  }
}

export function writePlaySession(session: StoredPlaySession): void {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(session));
  } catch {
    /* ignore */
  }
}

export function clearPlaySession(): void {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

export function playSessionHeaders(
  wallet: string | null | undefined,
  extra?: HeadersInit,
): Headers {
  const h = new Headers(extra);
  if (wallet) h.set("X-Wallet-Address", wallet);
  const s = readPlaySession(wallet);
  if (s?.token) h.set("X-Play-Session", s.token);
  const token = getGrudgeToken();
  if (token) h.set("Authorization", `Bearer ${token}`);
  return h;
}
